export default __webpack_public_path__ + "static/media/pilule progestative.6a6d1d4b.png";